import React, { useMemo, useState } from 'react';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { HtmlTable } from '../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { PDFSafeTableHeaderCaption } from '../../CommonComponents/OPL/HtmlTable/components/PDFSafeTableHeaderCaption/PDFSafeTableHeaderCaption';
import { Icon } from '../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import formatAsCurrency from '../../CommonUtils/formatAsCurrency';
import { TableRow } from '../Dashboard.styles';
import { TopDashboardData } from '../api/useDashboardQuery';

interface Props {
  title: string;
  headers: string[];
  data: TopDashboardData[];
}

export const DashboardTable = ({ title, headers, data }: Props) => {
  const [isDescending, setIsDescending] = useState(true);

  const sortedData = useMemo(() => {
    return [...data].sort((a, b) => {
      const totalDiff = a.total - b.total;

      if (totalDiff === 0) {
        return a.name.localeCompare(b.name);
      }

      return isDescending ? -totalDiff : totalDiff;
    });
  }, [data, isDescending]);

  const handleToggleSort = () => {
    setIsDescending(prev => !prev);
  };

  return (
    <HtmlTable minHeight={200} width="48%" mb="24">
      <table style={{ tableLayout: 'fixed' }}>
        <colgroup>
          <col width="60%" />
          <col width="40%" />
        </colgroup>
        <thead>
          <PDFSafeTableHeaderCaption colSpan={2}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              {title}
              <Box
                display="flex"
                alignItems="center"
                aria-label={`Sort by ${headers[1]} ${isDescending ? 'descending' : 'ascending'}`}
                onClick={handleToggleSort}
              >
                <Icon
                  className={isDescending ? 'fas fa-sort-amount-down' : 'fas fa-sort-amount-up'}
                  height={24}
                />
              </Box>
            </Box>
          </PDFSafeTableHeaderCaption>
          <tr>
            <th>
              <Text variant="smallCaps" textAlign="left">
                {headers[0]}
              </Text>
            </th>
            <th>
              <Text variant="smallCaps" textAlign="right">
                {headers[1]}
              </Text>
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map(client => (
            <TableRow
              key={client.id}
              onClick={() => ADV.util.Router.go2('ConsumerOverview', { clientId: client.id })}
            >
              <td>
                <Text textAlign="left" isTruncated>
                  {client.name}
                </Text>
              </td>
              <td>
                <Text variant="tabular" textAlign="right" isTruncated>
                  {formatAsCurrency(client.total)}
                </Text>
              </td>
            </TableRow>
          ))}
        </tbody>
      </table>
    </HtmlTable>
  );
};
